<!-- Modal de Preferências de Acessibilidade (Primeiro Acesso) -->
<div class="accessibility-pref-modal" *ngIf="accessibilityModalOpen" role="dialog" aria-modal="true" aria-labelledby="acc-title">
  <div class="acc-modal-content">
    <h2 id="acc-title" class="visually-hidden">Preferências de Acessibilidade Blukit</h2>
    <p class="acc-intro">Olá! Seja bem-vindo à Blukit. Escolha abaixo as opções de acessibilidade para sua navegação:</p>
    <div class="acc-options">
      <div class="acc-option-group">
        <button id="btn-darkmode-pref" type="button" class="btn-acc-option" (click)="toggleDarkMode()" [attr.aria-pressed]="darkModeEnabled">
          <span>Modo Escuro (Dark Mode)</span>
          <span>{{ darkModeEnabled ? 'ATIVADO' : 'DESATIVADO' }}</span>
        </button>
        <p class="acc-option-desc">Substitui as cores claras por tons escuros e confortáveis para leitura noturna ou sensibilidade visual.</p>
      </div>
      <div class="acc-option-group">
        <button id="btn-vlibras-pref" type="button" class="btn-acc-option" (click)="toggleVLibras()" [disabled]="vlibrasLoading" [attr.aria-busy]="vlibrasLoading" [attr.aria-pressed]="vlibrasEnabled">
          <span>Tradução em Libras (VLibras)</span>
          <span class="vlibras-button-status">
            <span *ngIf="vlibrasLoading" class="vlibras-loader" aria-hidden="true"></span>
            {{ vlibrasLoading ? 'CARREGANDO' : (vlibrasEnabled ? 'ATIVADO' : 'DESATIVADO') }}
          </span>
        </button>
        <p class="acc-option-desc">Ativa o assistente de tradução automática dos textos para a Língua Brasileira de Sinais (LIBRAS).</p>
      </div>
    </div>
    <div class="acc-dont-show-again">
      <label class="d-flex align-items-center gap-2" style="cursor: pointer;">
        <input type="checkbox" [(ngModel)]="dontShowAgainChecked" />
        <span>Não mostrar este assistente novamente e ocultar barra de atalhos</span>
      </label>
    </div>
    <button type="button" class="btn-acc-save" (click)="saveAccessibilityPrefs()">
      Confirmar e Continuar
    </button>
  </div>
</div>

<span class="visually-hidden" aria-live="polite">
  {{ vlibrasLoading ? 'Carregando o recurso de Libras.' : (vlibrasLoadError ? 'Não foi possível carregar o recurso de Libras.' : '') }}
</span>

<!-- Barra de Acessibilidade Permanente -->
<div class="accessibility-bar" role="complementary" aria-label="Atalhos de acessibilidade" *ngIf="!hideAccessibilityBar">
  <div class="container-xl d-flex justify-content-between align-items-center py-1 flex-wrap gap-2">
    <a class="skip-link-bar" href="#main-content" accesskey="1" (click)="skipToMainContent($event)">Ir para o conteúdo principal [Alt + 1]</a>
    <div class="acc-bar-controls d-flex gap-2">
      <button type="button" class="btn-acc-bar" (click)="toggleDarkMode()" [attr.aria-pressed]="darkModeEnabled" [attr.aria-label]="darkModeEnabled ? 'Desativar Modo Escuro' : 'Ativar Modo Escuro'">
        Modo Escuro: {{ darkModeEnabled ? 'Ativo' : 'Inativo' }}
      </button>
      <button type="button" class="btn-acc-bar" (click)="toggleVLibras(true)" [disabled]="vlibrasLoading" [attr.aria-busy]="vlibrasLoading" [attr.aria-pressed]="vlibrasEnabled" [attr.aria-label]="vlibrasLoading ? 'Carregando VLibras' : (vlibrasEnabled ? 'Desativar VLibras' : 'Ativar VLibras')">
        <span *ngIf="vlibrasLoading" class="vlibras-loader" aria-hidden="true"></span>
        Libras: {{ vlibrasLoading ? 'Carregando' : (vlibrasEnabled ? 'Ativo' : 'Inativo') }}
      </button>
      <button type="button" class="btn-acc-bar" (click)="openAccessibilityModal()" aria-label="Abrir preferências de acessibilidade">
        Opções
      </button>
    </div>
  </div>
</div>

<app-navbar></app-navbar>
<main class="main-content" id="main-content" tabindex="-1">
  <router-outlet></router-outlet>
</main>
<app-footer style="padding: 0 1em;"></app-footer>

<!-- WhatsApp Widget Landmark -->
<aside aria-label="Atendimento pelo WhatsApp">
  <div *ngIf="showWhats" class="whats-modal-content">
    <button (click)="closeWhats()" class="btn-fechar-whats" aria-label="Fechar conversa do WhatsApp">
      X
    </button>
    <div
      style="display: flex; justify-content: space-between; background-color: #1e806a; height: 70px; align-items: flex-start; border-radius: 3px;">
      <img style="width: 50px; height: 50px; position: relative; top: 8px; left: 9px;"
        src="https://d335luupugsy2.cloudfront.net/cms/files/199144/1675430913/$bub8ax8kbvk"
        alt="Blukit - Soluções Hidráulicas">
      <span class="text-header-whats">Blukit - Soluções Hidráulicas</span>
      <span
        style="color: #fff; position: absolute; top: 36px; left: 72px; font-size: 14px; font-weight: bold;">Online</span>
    </div>
    <textarea *ngIf="!collectiveVacation" disabled id="w3review" name="w3review" rows="2" cols="50" class="hellow-whats">
    Olá, lojista! Informe seu nome para que possamos conversar melhor! 😊
  </textarea>
    <textarea *ngIf="collectiveVacation" disabled id="w3review" name="w3review" rows="4" cols="50"
      style="line-height: 1.3;font-size: 14px; width: 70%; padding: 1em; margin: 1em; background-color: #fff; overflow: hidden; resize: none;">
    Olá, lojista! Estamos aproveitando um período de descanso coletivo. Retornaremos cheios de energia e prontos para atendê-lo a partir do dia 09/01/2024! 😊
  </textarea>
    <form action="" [formGroup]="formWhatsApp" (submit)="onSubmit()">
      <input id="form-wp-name" formControlName="nome" type="text" placeholder="Nome *" class="input-form-wpp"
        [class.error]="
                  formWhatsApp.controls['nome'].errors &&
                  (formWhatsApp.controls['nome'].dirty ||
                  formWhatsApp.controls['nome'].touched ||
                  submitted
    )">
      <span class="text-danger error-wpp"
        *ngIf="formWhatsApp.controls['nome'].errors?.['required'] && (formWhatsApp.controls['nome'].dirty || (formWhatsApp.controls['nome'].touched) || submitted)">
        Nome é necessário.
      </span>
      <span class="text-danger error-wpp"
        *ngIf="!formWhatsApp.controls['nome'].errors?.['required'] && (formWhatsApp.controls['nome'].dirty || (formWhatsApp.controls['nome'].touched) || submitted) && formWhatsApp.controls['nome'].errors">
        Nome inválido.
      </span>
      <input id="form-wp-telefone" formControlName="telefone" type="text" placeholder="Telefone *" class="input-form-wpp"
        [class.error]="
                  formWhatsApp.controls['telefone'].errors &&
                  (formWhatsApp.controls['telefone'].dirty ||
                  formWhatsApp.controls['telefone'].touched ||
                  submitted
    )">
      <span class="text-danger error-wpp"
        *ngIf="formWhatsApp.controls['telefone'].errors?.['required'] && (formWhatsApp.controls['telefone'].dirty || (formWhatsApp.controls['telefone'].touched)|| submitted)">
        Telefone é necessário.
      </span>
      <span class="text-danger error-wpp"
        *ngIf="!formWhatsApp.controls['telefone'].errors?.['required'] && (formWhatsApp.controls['telefone'].dirty || (formWhatsApp.controls['telefone'].touched)|| submitted) && formWhatsApp.controls['telefone'].errors">
        Telefone inválido.
      </span>
      <input id="form-wp-email" formControlName="email" type="text" placeholder="Email *" class="input-form-wpp"
        [class.error]="
                  formWhatsApp.controls['email'].errors &&
                  (formWhatsApp.controls['email'].dirty ||
                  formWhatsApp.controls['email'].touched ||
                  submitted
    )">
      <span class="text-danger error-wpp"
        *ngIf="formWhatsApp.controls['email'].errors?.['required'] && (formWhatsApp.controls['email'].dirty || (formWhatsApp.controls['email'].touched)|| submitted)">
        E-mail é necessário.
      </span>
      <span class="text-danger error-wpp"
        *ngIf="!formWhatsApp.controls['email'].errors?.['required'] && (formWhatsApp.controls['email'].dirty || (formWhatsApp.controls['email'].touched)|| submitted) && formWhatsApp.controls['email'].errors">
        E-mail inválido.
      </span>
      <input id="form-wp-cnpj" formControlName="cnpj" type="text" placeholder="CNPJ *" class="input-form-wpp"
        [class.error]="
                  formWhatsApp.controls['cnpj'].errors &&
                  (formWhatsApp.controls['cnpj'].dirty ||
                  formWhatsApp.controls['cnpj'].touched ||
                  submitted
    )">
      <span class="text-danger error-wpp"
        *ngIf="formWhatsApp.controls['cnpj'].errors?.['required'] && (formWhatsApp.controls['cnpj'].dirty || (formWhatsApp.controls['cnpj'].touched)|| submitted)">
        CNPJ é necessário.
      </span>
      <span class="text-danger error-wpp"
        *ngIf="!formWhatsApp.controls['cnpj'].errors?.['required'] && (formWhatsApp.controls['cnpj'].dirty || (formWhatsApp.controls['cnpj'].touched)|| submitted) && formWhatsApp.controls['cnpj'].errors">
        CNPJ inválido.
      </span>
      <button type="submit" class="btn-start-conversation">
        Iniciar Conversa
      </button>
    </form>
  </div>
  <button type="button" class="icon-whatsapp" (click)="showWhats = !showWhats" aria-label="Abrir conversa no WhatsApp"
    style="background: transparent; border: 0; padding: 0;">
    <img src="/assets/icons/whatsapp_62px.png" alt="Abrir conversa no WhatsApp">
  </button>
</aside>

<!-- Rodapé Adicional LGPD Landmark -->
<aside aria-label="Informações legais e desenvolvimento">
  <div class="container-fluid bg bg-light text-center p-4 legal-footer" style="font-size: 12px;">
    <button type="button" style="cursor: pointer; background: transparent; border: 0; padding: 0;" (click)="openLgpd()">Lei Geral de Proteção de Dados (LGPD) / Política de Privacidade</button>
    <span>
      ---
    </span>
    <a href="https://www.mobilesales.com.br" target="_blank" class="small-link ">Desenvolvido por MobileSales Sistemas</a>
  </div>
</aside>

<!-- Cookies Consent Landmark -->
<aside class="accept-cookies p-4" aria-label="Consentimento de cookies" *ngIf="!cookiesAccepted && !accessibilityModalOpen">
  <div class="area-lgpd">
    <p class="title-lgpd">Políticas de Privacidade e Proteção de Dados</p>
    <p class="text-lgpd">Esta página faz uso de cookies para melhorar sua experiência de navegação em nossos serviços.
      Em concordância com as Leis de Proteção de Dados, é necessário que você accepte o uso deste recurso para que possa
      visitar o site. Você pode saber mais sobre nossa Política de Privacidade e Proteção de dados pessoais nos links abaixo.
      <br> <span>Para avançar clique no botão “Aceitar”</span>
    </p>
    <div class="d-flex flex-wrap gap-2">
      <a href="https://www.blukit.com.br/Politica-de-Privacidade-Blukit.pdf" target="_blank" class="card-cod-pro-home ler-lgpd">Ler Políticas de Privacidade</a>
      <button type="button" (click)="acceptCookies()" class="card-cod-pro-home aceitar-lgpd" aria-label="Aceitar cookies">Aceitar</button>
    </div>
  </div>
</aside>

<!-- VLibras Widget -->
<div vw class="enabled vlibras-widget-host" [class.vlibras-widget-enabled]="vlibrasEnabled">
  <div vw-access-button class="active"></div>
  <div vw-plugin-wrapper>
    <div class="vw-plugin-top-wrapper"></div>
  </div>
</div>
